export default class VariantVisibilityToggle extends HTMLElement {
  handleChange = (event) => {
    const isChecked = event.target.checked;
    if (isChecked) {
      this.closest('.variant-wrapper.js').classList.add('variants-visible');
    } else {
      this.closest('.variant-wrapper.js').classList.remove('variants-visible');
      this.variantGroup.querySelector('input[type="radio"]:not(.disabled)').checked = true;
      // this.addChoiceToStorage(this.option);
    }
  };

  addChoiceToStorage(option) {
    sessionStorage.setItem("selectedOptionVisible", option);
  }

  removeChoiceToStorage(option) {
    sessionStorage.removeItem("selectedOptionVisible", option);
  }

  connectedCallback() {
    this.inputRef = this.querySelector('input');
    this.variantGroup = this.closest('.variant-wrapper.js').querySelector('fieldset');
    this.option = this.getAttribute('controls');
    this.inputRef.addEventListener('change', this.handleChange);
  }
}

customElements.define('variant-toggle', VariantVisibilityToggle);
